module.exports = __webpack_public_path__ + "img/lcd_03.76fd593e.jpg";